/**
 * Frontend environment configuration.
 *
 * Values are injected at build time by Vite from `.env.*` files.
 * Fallbacks are provided so the app works even if a variable is missing.
 */
export const config = {
  /** Base URL for REST API calls (e.g. /api/v1 in prod, http://localhost:8080/api/v1 in dev). */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080",
  // apiBaseUrl: window.__ENV__?.API_URL;

  /** Base URL for serving uploaded/static images (e.g. /pics in prod). */
  picsBaseUrl: import.meta.env.VITE_PICS_BASE_URL ?? "/pics",

  /** Redirect URI used for OAuth2 login flows. */
  oauthRedirectUri: import.meta.env.VITE_OAUTH_REDIRECT_URI ?? "http://localhost:5173",
} as const;

export default config;
